import {
  GRAPHQL_ENDPOINT,
  SIGN_MEMBERSHIP_AGREEMENT_API,
} from '../utils/constants/EndpointUrls'
import { AXIOS_METHODS } from '../utils/constants/Enums'
import {
  BOULEVARD_PUBLIC_API_TOKEN,
  CUSTOMER_SESSION_TOKEN,
} from '../utils/constants/Helpers'
import { getLocalstorageItem, tokenValidator } from '../utils/helper-functions'
import {
  AddBookableItemToCartResponse,
  AddSelectedItemToCartPayload,
} from '../utils/types/cartTypes'
import { Axios } from './Axios'
import SanityClient from './sanityClient'

const getBoulevardClientHeader = () => {
  return {
    Authorization: `Basic ${getLocalstorageItem(BOULEVARD_PUBLIC_API_TOKEN)}`,
  }
}

/*
 * Mutations
 */

/*
 * Query
 */
const addSelectedToCartQuery = `query AddSelectedToCartQuery($cartId:String,$itemId:String){
  cart(id: $cartId) {
    id
    availableItem(id: $itemId) {
      id

      ... on CartAvailablePurchasableItem {
        name
        description
        listPriceRange {
          min
          max
          variable
        }
      }
    }
  }
}`
const addCartSelectedPurchasableItem = `mutation AddCartSelectedPurchasableItem($id:String,$itemId:String){
  addCartSelectedPurchasableItem(input: {
    id:$id,
    itemId:$itemId
  }) {
    cart {
      id
      summary{
  gratuityAmount
  paymentMethodRequired
  subtotal
  taxAmount
  total
  depositAmount
  deposit
      }
    }
  }
}`
/*
 * API calls
 */

export const addSelectedItemToCart = async (cartId: string, itemId: string) => {
  const payload: AddSelectedItemToCartPayload = {
    query: addSelectedToCartQuery,
    variables: {
      cartId,
      itemId,
    },
  }

  const response = await Axios.setHeaders(getBoulevardClientHeader()).callApi<
    AddSelectedItemToCartPayload,
    AddBookableItemToCartResponse
  >(AXIOS_METHODS.POST, GRAPHQL_ENDPOINT, undefined, payload)
  if (response.data) {
    return response.data
  } else {
    throw new Error(response.message)
  }
}

export const addSelectedPurchasableItemToCart = async (
  id: string,
  itemId: string
) => {
  const payload: AddSelectedItemToCartPayload = {
    query: addCartSelectedPurchasableItem,
    variables: {
      id,
      itemId,
    },
  }

  const response = await Axios.setHeaders(getBoulevardClientHeader()).callApi<
    AddSelectedItemToCartPayload,
    AddBookableItemToCartResponse
  >(AXIOS_METHODS.POST, GRAPHQL_ENDPOINT, undefined, payload)
  if (response.data) {
    return response.data
  } else {
    throw new Error(response.message)
  }
}

const agreementQuery = `*[_type == "legal" && title == "Membership Agreement" ]`

export const getMembershipAgreementPortableText = async () => {
  const response = await SanityClient.fetch(agreementQuery).catch(console.error)
  if (response) {
    return response[0].body
  } else {
    console.error(response)
    throw new Error(response)
  }
}

export const signMembershipAgreement = async (membershipAgreement: boolean) => {
  tokenValidator()
  const payload = {
    membershipAgreement,
  }
  const headers = {
    Authorization: `Bearer ${getLocalstorageItem(CUSTOMER_SESSION_TOKEN)}`,
  }
  const response = await Axios.setHeaders(headers).callApi<
    {
      membershipAgreement: boolean
    },
    any
  >(AXIOS_METHODS.PATCH, SIGN_MEMBERSHIP_AGREEMENT_API, undefined, payload)
  if (response.data) {
    return response.data
  } else {
    throw new Error(response.message)
  }
}
